export default "__VITE_ASSET__BViAuMrH__"